/* eslint-disable */
export enum FinnairItineraryItemType {
  FLIGHT = 'FLIGHT',
  LAYOVER = 'LAYOVER'
}

